<template>
    <div class="flex">
        <vs-switch v-model="mode" vs-icon-on="wb_sunny" class=" p-2"  vs-icon-off="brightness_3" @change="themeMode"/>

    </div>
</template>
<script>

export default {
    data(){
        return{
           mode: false
        }
    },
   /*computed:{
        themeMode: {
      get()    { return this.$store.state.theme },
      set() {
          console.log(val)
          var theme = 'dark'
          if(val == false){
              theme = 'light' 
             
          }
           this.$store.dispatch('updateTheme', theme)
        
            }
    },
   },*/
   watch:{
       mode(){
           this.themeMode()
       }
   },
   methods:{
       themeMode(){
            // console.log(this.mode)
          var theme = 'dark'
          if(this.mode == false){
              theme = 'light' 
             
          }
           this.$store.dispatch('updateTheme', theme)
        
       }
   }
   
    
    
}
</script>
<style lang="scss">
.rad{
    border-radius: 12px;
}
</style>